import React, { Component } from 'react';
import './Portfolio.scss';
import Card from './Card/Card.js';
import Gallery from './Gallery/Gallery.js';

//
// import images
//

import rebirth_top from './../../../images/rebirth/top.png';
import rebirth_middle from './../../../images/rebirth/middle.png';
import rebirth_bottom from './../../../images/rebirth/bottom.png';
//import rebirth_header from './../../../images/rebirth/rebirth_header.jpg';
import rebirth_cover from './../../../images/rebirth/rebirth_cover.jpg';
import rebirth_1 from './../../../images/rebirth/rebirth_1.jpg';
import rebirth_2 from './../../../images/rebirth/rebirth_2.jpg';
import rebirth_3 from './../../../images/rebirth/rebirth_3.jpg';
import rebirth_4 from './../../../images/rebirth/rebirth_4.jpg';
import rebirth_5 from './../../../images/rebirth/rebirth_5.jpg';
import rebirth_6 from './../../../images/rebirth/rebirth_6.jpg';
import rebirth_7 from './../../../images/rebirth/rebirth_7.jpg';
import rebirth_8 from './../../../images/rebirth/rebirth_8.jpg';
import rebirth_9 from './../../../images/rebirth/rebirth_9.jpg';
import rebirth_10 from './../../../images/rebirth/rebirth_10.jpg';
import rebirth_11 from './../../../images/rebirth/rebirth_11.jpg';
import rebirth_12 from './../../../images/rebirth/rebirth_12.jpg';
import rebirth_13 from './../../../images/rebirth/rebirth_13.jpg';
import rebirth_14 from './../../../images/rebirth/rebirth_14.jpg';
import rebirth_15 from './../../../images/rebirth/rebirth_15.jpg';
import rebirth_16 from './../../../images/rebirth/rebirth_16.jpg';
import rebirth_17 from './../../../images/rebirth/rebirth_17.jpg';
import rebirth_18 from './../../../images/rebirth/rebirth_18.jpg';
import rebirth_19 from './../../../images/rebirth/rebirth_19.jpg';
import rebirth_20 from './../../../images/rebirth/rebirth_20.jpg';
import rebirth_21 from './../../../images/rebirth/rebirth_21.jpg';
import rebirth_22 from './../../../images/rebirth/rebirth_22.jpg';
import rebirth_23 from './../../../images/rebirth/rebirth_23.jpg';
import rebirth_24 from './../../../images/rebirth/rebirth_24.jpg';
import rebirth_25 from './../../../images/rebirth/rebirth_25.jpg';
import rebirth_26 from './../../../images/rebirth/rebirth_26.jpg';
import rebirth_27 from './../../../images/rebirth/rebirth_27.jpg';
import rebirth_28 from './../../../images/rebirth/rebirth_28.jpg';
import rebirth_29 from './../../../images/rebirth/rebirth_29.jpg';
import rebirth_30 from './../../../images/rebirth/rebirth_30.jpg';
import rebirth_31 from './../../../images/rebirth/rebirth_31.jpg';
import rebirth_32 from './../../../images/rebirth/rebirth_32.jpg';
import rebirth_33 from './../../../images/rebirth/rebirth_33.jpg';
import rebirth_34 from './../../../images/rebirth/rebirth_34.jpg';

import rebirth_sample_1 from './../../../images/rebirth/rebirth_sample_1.jpg';
import rebirth_sample_2 from './../../../images/rebirth/rebirth_sample_2.jpg';
import rebirth_sample_3 from './../../../images/rebirth/rebirth_sample_3.jpg';
import rebirth_sample_4 from './../../../images/rebirth/rebirth_sample_4.jpg';
import rebirth_sample_5 from './../../../images/rebirth/rebirth_sample_5.jpg';
import rebirth_sample_6 from './../../../images/rebirth/rebirth_sample_6.jpg';
import rebirth_sample_7 from './../../../images/rebirth/rebirth_sample_7.jpg';
import rebirth_sample_8 from './../../../images/rebirth/rebirth_sample_8.jpg';
import rebirth_sample_9 from './../../../images/rebirth/rebirth_sample_9.jpg';
import rebirth_sample_10 from './../../../images/rebirth/rebirth_sample_10.jpg';
import rebirth_sample_11 from './../../../images/rebirth/rebirth_sample_11.jpg';
import rebirth_sample_12 from './../../../images/rebirth/rebirth_sample_12.jpg';
import rebirth_sample_13 from './../../../images/rebirth/rebirth_sample_13.jpg';

//import in_a_week_header from './../../../images/in_a_week/in_a_week_header.jpg';
import in_a_week_top from './../../../images/in_a_week/top.png';
import in_a_week_middle from './../../../images/in_a_week/middle.png';
import top from './../../../images/in_a_week/top.png';
import in_a_week_2 from './../../../images/in_a_week/in_a_week_2.jpg';
import in_a_week_3 from './../../../images/in_a_week/in_a_week_3.jpg';
import in_a_week_4 from './../../../images/in_a_week/in_a_week_4.jpg';
import in_a_week_5 from './../../../images/in_a_week/in_a_week_5.jpg';
import in_a_week_6 from './../../../images/in_a_week/in_a_week_6.jpg';
import in_a_week_7 from './../../../images/in_a_week/in_a_week_7.jpg';
import in_a_week_8 from './../../../images/in_a_week/in_a_week_8.jpg';
import in_a_week_9 from './../../../images/in_a_week/in_a_week_9.jpg';
import in_a_week_10 from './../../../images/in_a_week/in_a_week_10.jpg';
import in_a_week_11 from './../../../images/in_a_week/in_a_week_11.jpg';
import in_a_week_12 from './../../../images/in_a_week/in_a_week_12.jpg';
import in_a_week_13 from './../../../images/in_a_week/in_a_week_13.jpg';
// import in_a_week_14 from './../../../images/in_a_week/in_a_week_14.jpg';

import in_a_week_sample_1 from './../../../images/in_a_week/in_a_week_sample_1.jpg';
import in_a_week_sample_2 from './../../../images/in_a_week/in_a_week_sample_2.jpg';
import in_a_week_sample_3 from './../../../images/in_a_week/in_a_week_sample_3.jpg';
import in_a_week_sample_4 from './../../../images/in_a_week/in_a_week_sample_4.jpg';
import in_a_week_sample_5 from './../../../images/in_a_week/in_a_week_sample_5.jpg';
import in_a_week_sample_6 from './../../../images/in_a_week/in_a_week_sample_6.jpg';
import in_a_week_sample_7 from './../../../images/in_a_week/in_a_week_sample_7.jpg';
import in_a_week_sample_8 from './../../../images/in_a_week/in_a_week_sample_8.jpg';
import in_a_week_sample_9 from './../../../images/in_a_week/in_a_week_sample_9.jpg';

import night_flight_header from './../../../images/night_flight/night_flight_header.jpg';
import night_flight_1 from './../../../images/night_flight/night_flight_1.jpg';
import night_flight_2 from './../../../images/night_flight/night_flight_2.jpg';
import night_flight_3 from './../../../images/night_flight/night_flight_3.jpg';
import night_flight_4 from './../../../images/night_flight/night_flight_4.jpg';
import night_flight_5 from './../../../images/night_flight/night_flight_5.jpg';
import night_flight_6 from './../../../images/night_flight/night_flight_6.jpg';

import night_flight_sample_1 from './../../../images/night_flight/night_flight_sample_1.jpg';
import night_flight_sample_2 from './../../../images/night_flight/night_flight_sample_2.jpg';
import night_flight_sample_3 from './../../../images/night_flight/night_flight_sample_3.jpg';
import night_flight_sample_4 from './../../../images/night_flight/night_flight_sample_4.jpg';
import night_flight_sample_5 from './../../../images/night_flight/night_flight_sample_5.jpg';
import night_flight_sample_6 from './../../../images/night_flight/night_flight_sample_6.jpg';
import night_flight_sample_7 from './../../../images/night_flight/night_flight_sample_7.jpg';
import night_flight_sample_8 from './../../../images/night_flight/night_flight_sample_8.jpg';

import trend_2020_cover from '../../../images/trend_2020/trend portfolio COVER.png';

import trend_2020_bg1 from '../../../images/trend_2020/trend-portfolio bg.png';
import trend_2020_bg2 from '../../../images/trend_2020/trend-portfolio bg2.png';
import trend_2020_bg3 from '../../../images/trend_2020/trend-portfolio bg3.png';
import trend_2020_bg4 from '../../../images/trend_2020/trend-portfolio bg4.png';
import trend_2020_bg5 from '../../../images/trend_2020/trend-portfolio bg5.png';
import trend_2020_bg6 from '../../../images/trend_2020/trend-portfolio bg6.png';

//
// component
//

class Portfolio extends Component {
  constructor(props) {
    super(props);

    this.Rebirth = this.Rebirth.bind(this);
    this.InAWeek = this.InAWeek.bind(this);
    this.NightFlight = this.NightFlight.bind(this);
    this.Trend2020 = this.Trend2020.bind(this);

    this.state = {
      project: props.project
    }

  }

  componentWillReceiveProps(newProps) {
    this.setState({project: newProps.project})
  }

  Trend2020() {
    return (
      <>
        <Card type={"image-header"} row={1} column={[1, 12]} image={trend_2020_cover} />
        <Card type={"image-header"} row={2} column={[1, 12]} image={trend_2020_bg1} />
        <Card type={"image-header"} row={3} column={[1, 12]} image={trend_2020_bg2} />
        <Card type={"image-header"} row={4} column={[1, 12]} image={trend_2020_bg3} />
        <Card type={"image-header"} row={5} column={[1, 12]} image={trend_2020_bg4} />
        <Card type={"image-header"} row={6} column={[1, 12]} image={trend_2020_bg5} />
        <Card type={"image-header"} row={7} column={[1, 12]} image={trend_2020_bg6} />
      </>
    )
  }

//        <Card type={"header-white"} row={1} column={[1, 12]} contents={"Rebirth"} />
//        <Card type={"text-centered-note"} row={2} column={[1, 12]} contents="~ 2019 ~"/>
//        <Card type={"text-no-padding"} row={3} column={[5, 8]} contents={
//          <>
//            In continuation from my Pre-Collection <em>In a Week</em>, <em>Rebirth</em> is inspired by the beauty of decay, and the birth of new life from the death of old.<br />
//            <br />
//            <em>
//              'We lay here for years or for hours<br />
//              Thrown here or found<br />
//              To freeze or to thaw<br />
//              So long we become the flowers<br />
//              Two corpses we were<br />
//              Two corpses I saw’
//            </em>
//          </>
//        } />

  Rebirth() {
    return (
      <>
        <Card type={"image-header"} row={[1, 4]} column={[1, 12]} image={rebirth_top} />

        <Gallery row={5} column={[1, 12]} onClick={this.props.focusOnImage} contents={[
          {image: rebirth_cover},
          {image: rebirth_1},
          {image: rebirth_2},
          {image: rebirth_3},
          {image: rebirth_4},
          {image: rebirth_5},
          {image: rebirth_6},
          {image: rebirth_7},
          {image: rebirth_8},
          {image: rebirth_9},
          {image: rebirth_10},
          {image: rebirth_11},
          {image: rebirth_12},
          {image: rebirth_13},
          {image: rebirth_14},
          {image: rebirth_15},
          {image: rebirth_16},
          {image: rebirth_17},
          {image: rebirth_18},
          {image: rebirth_19},
          {image: rebirth_20},
          {image: rebirth_21},
          {image: rebirth_22},
          {image: rebirth_23},
          {image: rebirth_24},
          {image: rebirth_25},
          {image: rebirth_26},
          {image: rebirth_27},
          {image: rebirth_28},
          {image: rebirth_29},
          {image: rebirth_30},
          {image: rebirth_31},
          {image: rebirth_32},
          {image: rebirth_33},
          {image: rebirth_34}
        ]}/>

        <Card type={"image-header"} row={[6, 8]} column={[1, 12]} image={rebirth_middle} />

        <Gallery row={9} column={[1, 12]} onClick={this.props.focusOnImage} contents={[
          {image: rebirth_sample_1},
          {image: rebirth_sample_3},
          {image: rebirth_sample_2},
          {image: rebirth_sample_4},
          {image: rebirth_sample_5},
          {image: rebirth_sample_6},
          {image: rebirth_sample_7},
          {image: rebirth_sample_8},
          {image: rebirth_sample_9},
          {image: rebirth_sample_10},
          {image: rebirth_sample_11},
          {image: rebirth_sample_12},
          {image: rebirth_sample_13}
        ]}/>

        <Card type={"image-header"} row={[10, 12]} column={[1, 12]} image={rebirth_bottom} />

      </>
    )
  }


//        <Card type={"text-no-padding"} row={4} column={[5, 8]} contents={
//          <>
//            This collection is inspired by Hozier’s song <em>‘In a Week’</em>, a romantic song about two lovers who want to lie together for evermore. The song has a dark side, as it also describes how they will eventually decay, be decomposed, and return to the earth.
//          </>
//        } />

  InAWeek() {
    return (
      <>
        <Card type={"image-header"} row={[1, 4]} column={[1, 12]} image={in_a_week_top} />

//        <Card type={"text-centered-note"} row={3} column={[1, 12]} contents="~ 2019 ~"/>

        <Gallery row={5} column={[1, 12]} onClick={this.props.focusOnImage} contents={[
          {image: in_a_week_2},
          {image: in_a_week_3},
          {image: in_a_week_4},
          {image: in_a_week_5},
          {image: in_a_week_6},
          {image: in_a_week_7},
          {image: in_a_week_8},
          {image: in_a_week_9},
          {image: in_a_week_10},
          {image: in_a_week_11},
          {image: in_a_week_12},
          {image: in_a_week_13}
        ]}/>

        <Card type={"image-header"} row={[6, 9]} column={[1, 12]} image={in_a_week_middle} />

        <Gallery row={10} column={[1, 12]} onClick={this.props.focusOnImage} contents={[
          {image: in_a_week_sample_1},
          {image: in_a_week_sample_2},
          {image: in_a_week_sample_3},
          {image: in_a_week_sample_4},
          {image: in_a_week_sample_5},
          {image: in_a_week_sample_6},
          {image: in_a_week_sample_7},
          {image: in_a_week_sample_8},
          {image: in_a_week_sample_9}
        ]}/>
      </>
    )
  }

  NightFlight() {
    return (
      <>
        <Card type={"image-header"} row={1} column={[1, 12]} image={night_flight_header} />
        <Card type={"header-white"} row={1} column={[1, 12]} contents={"Night Flight"} />

        <Card type={"text-centered-note"} row={2} column={[1, 12]} contents="~ 2019 ~"/>

        <Card type={"text-no-padding"} row={3} column={[5, 8]} contents={
          <>
            Combining 70s influences with inspiration from the natural world. I looked at butterfly wings for pattern and colour inspiration, while also looking at 70s disco dancefloors and contrasting the two themes.
          </>
          } />

        <Gallery row={4} column={[1, 12]} onClick={this.props.focusOnImage} contents={[
          {image: night_flight_1},
          {image: night_flight_2},
          {image: night_flight_6},
          {image: night_flight_4},
          {image: night_flight_3},
          {image: night_flight_5},
          {image: night_flight_6}
        ]}/>

        <Gallery row={5} column={[1, 12]} onClick={this.props.focusOnImage} contents={[
          {image: night_flight_sample_1},
          {image: night_flight_sample_2},
          {image: night_flight_sample_3},
          {image: night_flight_sample_4},
          {image: night_flight_sample_5},
          {image: night_flight_sample_6},
          {image: night_flight_sample_7},
          {image: night_flight_sample_8}
        ]}/>

      </>
    );
  }

  render() {
    var project = {
      rebirth: <this.Rebirth />,
      in_a_week: <this.InAWeek />,
      night_flight: <this.NightFlight />,
      trend_2020: <this.Trend2020 />
    }[this.state.project];

    return (
      <div className='Portfolio'>
        {project}
      </div>

    )
  }
}

export default Portfolio;
